// === GESTIONNAIRE DU CODEX ===
// Traque les ennemis tués et items découverts pour l'encyclopédie.
// Persistance localStorage.

const STORAGE_KEY = 'deadtide_codex';

interface CodexData {
  discoveredEnemies: string[];
  discoveredItems: string[];
}

export class CodexManager {
  private data: CodexData;

  constructor() {
    this.data = this.load();
  }

  // === ENNEMIS ===

  discoverEnemy(type: string): void {
    if (!this.data.discoveredEnemies.includes(type)) {
      this.data.discoveredEnemies.push(type);
      this.save();
    }
  }

  isEnemyDiscovered(type: string): boolean {
    return this.data.discoveredEnemies.includes(type);
  }

  getDiscoveredEnemies(): string[] {
    return [...this.data.discoveredEnemies];
  }

  // === ITEMS ===

  discoverItem(id: string): void {
    if (!this.data.discoveredItems.includes(id)) {
      this.data.discoveredItems.push(id);
      this.save();
    }
  }

  isItemDiscovered(id: string): boolean {
    return this.data.discoveredItems.includes(id);
  }

  getDiscoveredItems(): string[] {
    return [...this.data.discoveredItems];
  }

  // === STATS ===

  getEnemyCount(): number { return this.data.discoveredEnemies.length; }
  getItemCount(): number { return this.data.discoveredItems.length; }

  // === PERSISTENCE ===

  private save(): void {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(this.data));
    } catch { /* */ }
  }

  private load(): CodexData {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (raw) {
        const d = JSON.parse(raw);
        return {
          discoveredEnemies: Array.isArray(d.discoveredEnemies) ? d.discoveredEnemies : [],
          discoveredItems: Array.isArray(d.discoveredItems) ? d.discoveredItems : [],
        };
      }
    } catch { /* */ }
    return { discoveredEnemies: [], discoveredItems: [] };
  }

  resetAll(): void {
    this.data = { discoveredEnemies: [], discoveredItems: [] };
    this.save();
  }
}
